

































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Loading from '@/components/Loading.vue'
import MutationForm from '@/components/form/MutationForm.vue'
import errorBg from '@/assets/error_bg.jpg'
import defaultBg from '@/assets/login_bg0.jpg'
import defaultLogo from '@/assets/icono_horizontal.svg'
import { Environment, Session } from '@/models'
import gql from 'graphql-tag'
import { ApolloError } from 'apollo-client'
import StatusBar from '@/components/mobileApp/StatusBar.vue'
import { alert } from '@/components/dialogs'
import getEnv from '@/plugins/getEnv'

@Component({
  name: 'Login',
  components: {
    Loading,
    MutationForm,
    StatusBar
  }
})
export default class Login extends Vue {
  @Prop({ type: String, default: '' }) domain!: string
  desktopApp = !!getEnv('VUE_APP_IS_DESKTOP')

  email = ''
  password = ''
  authenticating = true
  forgot = false

  get environment(): Partial<Environment> | null {
    return this.$store.state.environment.environment
  }

  @Watch('environment', { immediate: true })
  async setEnvironmentVariables(env: Environment) {
    if (!env) return
    if (env.redirect && env.redirectUrl) {
      const url = env.redirectUrl.endsWith('/')
        ? env.redirectUrl.slice(0, -1)
        : env.redirectUrl
      return window.location.assign(`${url}${this.$route.query.to as string}`)
    }
    const style = document.getElementById('customCSS') as HTMLStyleElement
    if (env.accentColor) {
      this.$vuetify.theme.themes.light.primary =
        this.$vuetify.theme.themes.light.secondary =
        this.$vuetify.theme.themes.light.accent =
          env.accentColor
      this.$vuetify.theme.themes.dark.primary =
        this.$vuetify.theme.themes.dark.secondary =
        this.$vuetify.theme.themes.dark.accent =
          env.accentColor
    }
    if (env.useCustomCss && env.customCss) {
      style.innerText = env.customCss
    } else {
      style.innerText = ''
    }
    if (env.analyticsId) {
      gtag('config', env.analyticsId)
    }
  }

  get loggedIn() {
    return this.$store.getters['auth/loggedIn']
  }

  get user() {
    return this.$store.state.auth.user
  }

  get userAvatar() {
    return this.$store.getters['auth/userAvatarURL']
  }

  get logo() {
    if (this.$apollo.loading) return ''
    if (this.environment && this.environment.loginLogo)
      return this.environment.loginLogo.url
    if (this.environment && this.environment.logo)
      return this.environment.logo.url
    return defaultLogo
  }

  get bgStyle() {
    let background
    if (this.environment && this.environment.authBackgroundImage) {
      background = `url(${this.environment.authBackgroundImage.url}) fixed center / cover`
    } else if (!this.$apollo.loading && this.domain && !this.environment) {
      background = `url(${errorBg}) fixed center / cover`
    } else if (!this.$apollo.loading) {
      background = `url(${defaultBg}) fixed center / cover`
    }
    return {
      background,
      padding: 0
    }
  }

  async mounted() {
    await this.$store.dispatch('environment/initializeEnvironment', this.domain)
    return this.resumeSession()
  }

  forgotSuccess() {
    alert(
      'Por favor sigue las instrucciones del correo que te enviamos (revisa también tu carpeta de SPAM si no llega a la bandeja de entrada)'
    ).catch()
    this.forgot = false
  }

  async resumeSession() {
    let authenticated = false
    try {
      authenticated = await this.$store.dispatch('auth/resumeSession')
    } catch (e) {}
    if (authenticated) {
      await this.$router.replace((this.$route.query.to as string) || '/')
    } else {
      if (window.mobileApp) {
        const bootstrapLong = document.getElementById('bootstrap-long')
        if (bootstrapLong) {
          bootstrapLong.remove()
        }
      }
      if (this.desktopApp) {
        return this.autoLoginDemoAccount()
      }
      if (this.$route.query.token) {
        return this.loginSuccess(
          JSON.parse(atob(this.$route.query.token as string))
        )
      }
      this.authenticating = false
    }
  }

  async autoLoginDemoAccount() {
    const { data } = await this.$apollo.mutate({
      mutation: gql`
        mutation loginWithPassword($email: String, $password: String) {
          result: loginWithPassword(email: $email, password: $password) {
            _id
            publicKey
            secretKey
            createdAt
            nonce
            lastCall
            userId
            locale
            roles
            emailVerified
            options
          }
        }
      `,
      variables: {
        email: 'demo@codeless.biz',
        password: 'codeless'
      }
    })
    this.loginSuccess(data.result)
  }

  async loginSuccess(session: Session) {
    this.authenticating = true
    await this.$store.dispatch('auth/loadSession', session)
    await this.$router.push((this.$route.query.to as string) || '/')
  }
}
